interface CountdownProps {
  timeLeft: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  };
}

const Countdown: React.FC<CountdownProps> = ({ timeLeft }) => {
  return (
    <div className="container-fluid py-4 Countdown-bg">
      <div className="px-3 sec-wrapper">
        <div className="row justify-content-center align-items-center">
          <div className="col-12 col-md-auto text-center text-md-start mb-3 mb-md-0">
            <span className="fw-semibold fs-4 pe-md-4 pe-0">
              Time Left
              <br className="d-none d-md-block" /> to Support
            </span>
          </div>
          <div className="col-12 col-md-auto">
            <div className="d-flex gap-4 justify-content-center align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center gap-1">
                <h1 className="h2 fw-bold font-fraunces text-primary-custom mb-0">
                  {timeLeft.days}
                </h1>
                <p className="mb-0">Days</p>
              </div>
              <div className="d-flex flex-column justify-content-center align-items-center gap-1">
                <h1 className="h2 fw-bold font-fraunces text-primary-custom mb-0">
                  {timeLeft.hours}
                </h1>
                <p className="mb-0">Hours</p>
              </div>
              <div className="d-flex flex-column justify-content-center align-items-center gap-1">
                <h1 className="h2 fw-bold font-fraunces text-primary-custom mb-0">
                  {timeLeft.minutes}
                </h1>
                <p className="mb-0">Minutes</p>
              </div>
              <div className="d-flex flex-column justify-content-center align-items-center gap-1">
                <h1 className="h2 fw-bold font-fraunces text-primary-custom mb-0">
                  {timeLeft.seconds}
                </h1>
                <p className="mb-0">Seconds</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
